import { connect } from 'react-redux';
import ScopeRow from './ScopeRow';
import { sortScopeItemsRequest, updateScopeFlag } from '../../../../../store/actions/scope.actions';

// import { scopeStatusLoading } from '../../../../../store/selectors/scope.selector';
const mapDispatchToProps = { 
    sortScopeItemsRequest,
    updateFlag: updateScopeFlag
};

const mapStateToProps = (state) => { 
    // const statusLoading = scopeStatusLoading(state);

    return { };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ScopeRow);
